import { Soup, Star, Flame, Drumstick, Beef, Leaf, Wheat, Users, Baby, IceCream, CupSoda, Salad, UtensilsCrossed, Sparkles, ChefHat, Citrus } from "lucide-react";

export const MORE = "More from the kitchen";

// Styling ONLY (owner, June 2026): category names/order come VERBATIM from the POS feed.
// This map just picks a color/icon per feed name; unknown names get the default.
const STYLES = {
  "Handis": { hero: true, color: "#E8641E", Icon: Soup, tag: "BEST VALUE" },
  "Thalis": { hero: true, color: "#B71C1C", Icon: UtensilsCrossed, tag: "BEST VALUE" },
  "Starters & Chaat": { color: "#2A9D8F", Icon: Salad },
  "Tandoor & Grill": { color: "#C62828", Icon: Flame },
  "Chicken Curries": { color: "#E8743B", Icon: Drumstick },
  "Goat & Lamb Curries": { color: "#8E6CC4", Icon: Beef },
  "Fish & Shrimp Curries": { color: "#2A9D8F", Icon: Star },
  "Vegetarian Curries": { color: "#6BA368", Icon: Leaf },
  "Biryani": { color: "#B8892B", Icon: Sparkles },
  "Rice": { color: "#A0783C", Icon: Wheat },
  "Breads": { color: "#A0783C", Icon: Wheat },
  "Kids": { color: "#E26D9A", Icon: Baby },
  "Combos & Family Meals": { color: "#2A9D8F", Icon: Users },
  "Drinks & Lassi": { color: "#6BA368", Icon: CupSoda },
  "Desserts": { color: "#E26D9A", Icon: IceCream },
  "Sides & Chutneys": { color: "#8E6CC4", Icon: Citrus },
  "Indian Bowls": { color: "#E8743B", Icon: Soup },
  "Indian Chicken Wings": { color: "#C62828", Icon: Drumstick },
  "Loaded Masala Fries": { color: "#B8892B", Icon: UtensilsCrossed },
  "Naan Pockets": { color: "#A0783C", Icon: Wheat },
  "Stuffed Naan Burgers": { color: "#E8641E", Icon: ChefHat },
};
export const catStyle = (name) => STYLES[name] || { color: "#9a8f7c", Icon: ChefHat };

export const DISPLAY_CATS = [
  { key: "Handis", hero: true, color: "#E8641E", Icon: Soup, tag: "BEST VALUE" },
  { key: "Thalis", hero: true, color: "#B71C1C", Icon: UtensilsCrossed, tag: "BEST VALUE" },
  { key: "Urban Turban Specials", color: "#B8892B", Icon: Star },
  { key: "Starters", color: "#2A9D8F", Icon: Salad },
  { key: "Tandoor & Grill", color: "#C62828", Icon: Flame },
  { key: "Chicken Curries", color: "#E8743B", Icon: Drumstick },
  { key: "Goat & Lamb", color: "#8E6CC4", Icon: Beef },
  { key: "Vegetarian Curries", color: "#6BA368", Icon: Leaf },
  { key: "Biryani", color: "#B8892B", Icon: Sparkles },
  { key: "Breads & Rice", color: "#A0783C", Icon: Wheat },
  { key: "Combos & Family", color: "#2A9D8F", Icon: Users },
  { key: "Kids", color: "#E26D9A", Icon: Baby },
  { key: "Desserts", color: "#E26D9A", Icon: IceCream },
  { key: "Drinks & Lassi", color: "#6BA368", Icon: CupSoda },
  { key: "Condiments", color: "#8E6CC4", Icon: Citrus },
  { key: MORE, color: "#9a8f7c", Icon: ChefHat },
];

// display-only grouping of the POS categories — never hides a dish, never changes data
export function displayCategory(posCat, dishName) {
  const c = String(posCat || "").toLowerCase();
  const n = String(dishName || "").toLowerCase();
  if (n.includes("handi") || n.includes("matka")) return "Handis";
  if (c.includes("thali") || n.includes("thali")) return "Thalis";
  if (c.includes("special")) return "Urban Turban Specials";
  if (c.includes("starter") || c.includes("appetizer")) return "Starters";
  if (c.includes("tandoor")) return "Tandoor & Grill";
  if (c.includes("non-veg") || c.includes("non veg")) return /goat|lamb|mutton|gosht/.test(n) ? "Goat & Lamb" : "Chicken Curries";
  if (c.includes("goat") || c.includes("lamb")) return "Goat & Lamb";
  if (c.includes("chicken")) return "Chicken Curries";
  if (c.includes("veg")) return "Vegetarian Curries";
  if (c.includes("biryani")) return "Biryani";
  if (c.includes("bread") || c.includes("rice")) return "Breads & Rice";
  if (c.includes("combo") || c.includes("family")) return "Combos & Family";
  if (c.includes("kids") || c.includes("chote dhaba")) return "Kids";
  if (c.includes("dessert") || c.includes("sweet") || c.includes("mithai")) return "Desserts";
  if (c.includes("drink") || c.includes("lassi") || c.includes("shake")) return "Drinks & Lassi";
  if (c.includes("condiment") || c.includes("chutney") || c.includes("raita") || c.includes("sauce") || c.includes("side")) return "Condiments";
  return MORE;
}
